const config = {
    minGo: 50,
    pricingGo: {
        50 : {
            blackblaze: 4,
            aws: 8
        },
        200 : {
            blackblaze: 12,
            aws: 24
        },
        500 : {
            blackblaze: 26,
            aws: 52
        },
        1000 : {
            blackblaze: 40,
            aws: 80
        }
    },
    pricingLic: {
        base: {
            price: 2.5,
            per: 'poste',
            label: 'Protection de base'
        },
        disk: {
            price: 3.75,
            per: 'poste',
            label: 'Image disque'
        },
        MS365: {
            price: 1.5,
            per: 'utilisateur 365',
            label: 'Microsoft 365'
        },
        hv: {
            price: 1.5,
            per: 'hôte',
            label: 'Hyper-V'
        },
        exch: {
            price: 1.5,
            per: 'serveur',
            label: 'Serveur Exchange'
        },
        mssql: {
            price: 1.5,
            per: 'serveur',
            label: 'Bases de données SQL Server'
        },
        mongo: {
            price: 1.5,
            per: 'serveur',
            label: 'Bases de données MongoDB'
        }
    }
};
export default config;